import LoseWeightJourney from "./LoseWeightJourney";

export default LoseWeightJourney;
